<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="AiLoyalty" :aria-label="$t('hotel.loyalty.sectionTitle')">
    <article class="Layout LoyaltyBlock">
      <div class="Layout-section AiLoyalty">
        <grid-item
          class="AiLoyalty-logoContent"
          sm="4"
          :offset-md="offsetMdLogo"
          :md="mdLogo">
          <ai-logo
            :size="{
              height: 62,
              width: 158,
            }" />
        </grid-item>

        <grid-item class="AiLoyalty-content" sm="4" :md="mdContent">
          <div class="AiLoyalty-separatorContent">
            <ai-separator
              class="AiLoyaltyBlock-separator"
              vertical
              :margin="3" />

            <ai-separator class="AiLoyaltyBlock-separator" :margin="3" />
          </div>

          <div>
            <ai-typo
              class="AiLoyalty-title"
              as="h2"
              variant="heading-03"
              v-html="title" />

            <slot name="mainContent" />

            <slot name="actionContent" />
          </div>
        </grid-item>
      </div>
    </article>
  </section>
</template>

<script setup lang="ts">
type Props = {
  title: string;
  mdLogo: string;
  mdContent: string;
  offsetMdLogo?: string;
};

defineProps<Props>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/mixins';
.AiLoyalty {
  background: colors.$gold-100;
}
.LoyaltyBlock {
  padding-top: constants.$padding-07;
  padding-bottom: constants.$padding-07;
}

.AiLoyalty-content {
  display: flex;
  flex-direction: column;

  @media (mq.$from-medium) {
    flex-direction: row;
  }
}

.AiLoyalty-logoContent {
  display: flex;
  justify-content: center;
  align-items: center;
}

.AiLoyalty-separatorContent {
  @media (mq.$from-medium) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.AiLoyaltyBlock-separator {
  @media (mq.$from-medium) {
    @include mixins.rem-fallback(height, 196);
  }
}

.AiLoyalty-title {
  margin-bottom: constants.$margin-01;
  text-align: center;

  @media (mq.$from-medium) {
    text-align: start;
  }
}
</style>
